import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { FHEContainer, FHEContainerScroll, FHEContainerForm, FHEBoxAutoComplete, FHEButton } from 'data/components';
import { Logger } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { AddProductTitle, WizardAddProduct } from './components/provisionning';

class ProductAdd extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        boxes: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        boxMac: PropTypes.string
    };
    static defaultProps = {
        boxMac: null
    };

    constructor(props) {
        super(props);
        const { boxMac } = props;
        this.state = {
            boxMac,
            provisionning: !!boxMac
        };
    }

    handleChangeBoxAutoComplete = (field, value) => {
        value = value.replace(/:/g, '');
        this.setState({
            boxMac: value
        });
    };

    toggleProvisionning = () => {
        const { provisionning } = this.state;
        this.setState({ provisionning: !provisionning });
    };

    goBack = () => {
        const { history } = this.props;
        Logger.verbose('Redirect to backPage');
        return history.goBack();
    };

    getBoxesChoices = () => {
        const { boxes } = this.props;
        let choices = [];

        boxes.map((box, boxMac) => {
            choices.push({ mac: boxMac, id: box.get('boxId') });
        });

        return choices;
    };

    renderProvisonning = () => {
        const { boxMac } = this.state;
        return <WizardAddProduct homeBoxMac={boxMac} resetProduct={this.toggleProvisionning} goBack={this.goBack} />;
    };

    emptyFunc = () => {
        return <div />;
    };

    renderForm = () => {
        const { boxMac } = this.state;
        const { location, history } = this.props;

        return (
            <Grid container justify="center" alignItems="center" spacing={3}>
                {!location.state && (
                    <Grid container item sm={12} md={6} xl={4} justify="center" alignItems="center" direction="column">
                        <FHEBoxAutoComplete
                            id="boxMac"
                            baseValue={boxMac ? boxMac : ''}
                            label={Translator.translate(
                                `generic.products.addProduct.selectBoxes`,
                                Translator.translate(`${history.environment}.centerName`)
                            )}
                            name="boxMac"
                            data={this.getBoxesChoices()}
                            selectData={this.handleChangeBoxAutoComplete}
                        />
                    </Grid>
                )}

                <Grid container direction="column" justify="center" alignItems="center">
                    <Grid container item sm={12} md={6} xl={4} justify="center" alignItems="center" direction="column">
                        <FHEButton
                            disabled={!boxMac}
                            tooltip={
                                !boxMac
                                    ? Translator.translate(
                                          `generic.products.addProduct.startInclusion.tooltip`,
                                          Translator.translate(`${history.environment}.centerName`)
                                      )
                                    : null
                            }
                            content={Translator.translate(`generic.products.addProduct.startInclusion.title`)}
                            clickFunction={this.toggleProvisionning}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} xl={4} justify="center" alignItems="center" direction="column">
                        <FHEButton content={Translator.translate(`generic.products.addProduct.goBack`)} clickFunction={this.goBack} />
                    </Grid>
                </Grid>
            </Grid>
        );
    };
    render() {
        const { boxMac, provisionning } = this.state;
        return (
            <FHEContainer withBackIcon>
                <AddProductTitle key={boxMac} boxMac={boxMac} subTitle={!!(boxMac && provisionning)} />
                <FHEContainerScroll>
                    <FHEContainerForm>{provisionning ? this.renderProvisonning() : this.renderForm()}</FHEContainerForm>
                </FHEContainerScroll>
            </FHEContainer>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const boxMac = props.location.state && props.location.state.boxMac ? props.location.state.boxMac : null;
    const boxes = state.environments[history.environment].data.Boxes.get('list').filter(Box => {
        return Box.get('homeId') !== null && ['active', 'provisioned'].indexOf(Box.get('boxState')) !== -1;
    });

    return {
        profile: state.data.user,
        boxMac,
        boxes
    };
}

export default withRouter(renderEnvComponent('scenes/Products/add', connect(mapStateToProps)(ProductAdd)));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/add.js